import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function SocialProofBar() {
  return <FadeIn data-id="element-383">
      <div className="w-full bg-white border-y border-[#e2e8f0] py-6 shadow-sm" data-id="element-384">
        <div className="max-w-5xl mx-auto px-4 flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-center font-bold" data-id="element-385">
          <div className="text-lg text-[#0f172a]" data-id="element-386">+300 ciclistas</div>
          <div className="hidden sm:block text-[#e2e8f0]" data-id="element-387">•</div>
          <div className="text-lg text-[#0f172a]" data-id="element-388">6 Tomos</div>
          <div className="hidden sm:block text-[#e2e8f0]" data-id="element-389">•</div>
          <div className="text-lg text-[#0f172a]" data-id="element-390">6 Bonos</div>
          <div className="hidden sm:block text-[#e2e8f0]" data-id="element-391">•</div>
          <div className="flex items-center gap-1 text-lg text-[#0f172a]" data-id="element-392">
            4,9/5
            <div className="flex text-[#22c55e] ml-1" data-id="element-393">
              <Star size={18} fill="currentColor" data-id="element-394" />
            </div>
          </div>
        </div>
      </div>
    </FadeIn>;
}